import http from './httpService';

const apiEndPoint = '/debits';

function debitUrl(id) {
  return `${apiEndPoint}/${id}`;
}

export function getDebits() {
  return http.get(apiEndPoint);
}

export function getDebit(debitId) {
  return http.get(debitUrl(debitId));
}

export function saveDebit(debit) {
  if (debit._id) {
    const body = { ...debit };
    delete body._id;
    return http.put(debitUrl(debit._id), body);
  }

  return http.post(apiEndPoint, debit);
}

export function deleteDebit(debitId) {
  return http.delete(debitUrl(debitId));
}
